import React, { useEffect } from 'react'
import { Box } from '@mui/material'
import Card from '@mui/material/Card'
import { Typography } from '@mui/material'
import Translations from 'src/@core/layouts/components/Translations'
import { t } from 'i18next'
import { Line } from 'react-chartjs-2'
import { PastureGrowth } from 'src/@types'
import { getCampaign } from 'src/@core/utils/get-campaign'
import { useSelector } from 'react-redux'
import { AppDispatch, RootState } from 'src/store'
import { useDispatch } from 'react-redux'
import { fetchDateOfModel } from 'src/store/slices/reportSlice'


interface Props {
  pastureGrowth: PastureGrowth[]
  landId: number
}

const GrassGrowth = ({ pastureGrowth, landId }: Props) => {
  const labels = [t('Jul'), t('Aug'), t('Sep'), t('Oct'), t('Nov'), t('Dec'), t('Jan'), t('Feb'), t('Mar'), t('Apr'), t('May'), t('Jun')]

  const averageData = pastureGrowth
    .filter(element => element.pastureDataType === 'tc_mean')
    .sort(function (a, b) {
      if (labels.indexOf(t(a.month)) > labels.indexOf(t(b.month))) return 1
      else return -1
    })

  const currentData = pastureGrowth
    .filter(element => element.pastureDataType === 'tc_mean_ultimo_cicle')
    .sort(function (a, b) {
      if (labels.indexOf(t(a.month)) > labels.indexOf(t(b.month))) return 1
      else return -1
    })
  const dpDate = useSelector((state: RootState) => state.report.checkDpDate)
  const dispatch = useDispatch<AppDispatch>()

  const servingsHarvestable = `${landId}%2F${new Date().getFullYear() - 1
    }_${new Date().getFullYear()}%2FSERVINGS_HARVESTABLE_RASTER.tif`

  useEffect(() => {
    dispatch(fetchDateOfModel(servingsHarvestable))
  }, [servingsHarvestable])

  const data = {
    labels: labels,
    datasets: [
      {
        label: t('Average last 5 years'),
        backgroundColor: '#D9D9D9',
        borderColor: '#D9D9D9',
        data: averageData.map(month => month.pasture)
      },
      {
        label: dpDate ? getCampaign(new Date(dpDate)) : ' ',
        borderColor: '#005030',
        backgroundColor: '#005030',
        data: currentData.map(month => month.pasture)
      }
    ]
  }

  const options = {
    plugins: {
      legend: {
        labels: {
          color: '#5B5B98'
        }
      }
    }
  }

  return (
    <>
      <Card
        sx={{
          height: '495px',
          boxShadow: 'none',
          borderRadius: '20px',
          padding: '20px',
          position: 'relative'
        }}
      >
        <Typography
          variant='body2'
          sx={{
            fontSize: '13px !important',
            fontWeight: 400,
            display: 'flex',
            color: 'black',
            justifyContent: 'center',
            transform: 'rotate(90deg)  rotate(180deg)',
            position: 'absolute',
            marginTop: '27%',
            marginLeft: '-80px'
          }}
          className='cards-title'
        >
          <Translations text={'Growth rate (kgMS/ha/month)'} />
        </Typography>
        <Box
          sx={{
            mt: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            paddingBottom: '10px'
          }}
          className='for-dark-bottom-border'
        >
          <Typography
            variant='h3'
            sx={{
              fontSize: '18px !important',
              fontWeight: 700
            }}
          >
            <Translations text={'Grass growth chart'} />
          </Typography>
        </Box>
        <Box sx={{ ml: '8%', width: '93%', height: '85%' }}>
          <Line data={data} options={options} height={180} />
          <Typography
            variant='body2'
            sx={{
              mt: 3,
              fontSize: '15px !important',
              fontWeight: 400,
              width: '96%',
              display: 'flex',
              color: 'black',
              justifyContent: 'center'
            }}
          >
            <Translations text={'Mes'} />
          </Typography>
        </Box>
      </Card>
    </>
  )
}

export default GrassGrowth
